import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box } from '@mui/material';
import { Bedtime, Cancel } from '@mui/icons-material';
import { REFUND_STATUSES } from '@/utility';
import { useConfirmation } from '@/context/ConfirmationContext';
import axios from 'axios';
import { API_BASE_URL } from '@/config';
import { useTranslation } from 'react-i18next';

const ITEM_HEIGHT = 48;

export default function ExceptionsLongMenu({
  refundPath,
  refund,
  refetchRefunds,
}) {
  const { t } = useTranslation();
  const { requestConfirmation } = useConfirmation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const statusAction = async ({ path, id, comment }) => {
    await axios.post(`${API_BASE_URL}/${path}/${id}`, {
      params: { comment },
    });
    refetchRefunds();
  };

  const handleSetToDormant = () => {
    handleClose();
    requestConfirmation(
      'Are you sure you want to set this refund to dormant? This action will mark the refund as inactive.',
      (comment) => {
        statusAction({
          path: `set-to-dormant/${refundPath}`,
          id: refund.id,
          comment,
        });
      },
      null,
      {
        showCommentField: true,
        commentLabel: 'Reason for setting to dormant',
        commentPlaceholder:
          'Please provide a reason for setting this refund to dormant...',
        commentRequired: true,
      },
    );
  };

  const handleCancelRefund = () => {
    handleClose();
    requestConfirmation(
      'Are you sure you want to cancel this refund?',
      (comment) => {
        statusAction({
          path: `cancel-refund/${refundPath}`,
          id: refund.id,
          comment,
        });
      },
      null,
      {
        showCommentField: true,
        commentLabel: 'Reason for canceling the refund',
        commentPlaceholder:
          'Please provide a reason for canceling the refund...',
        commentRequired: true,
      },
    );
  };

  return (
    <div>
      <IconButton
        aria-label='more'
        id='long-button'
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup='true'
        onClick={handleClick}
        size='large'>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='long-menu'
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 10,
            minWidth: '250px',
          },
        }}>
        <MenuItem onClick={() => handleCancelRefund()}>
          <Box display='flex' gap='10px'>
            <Cancel style={{ color: '#3AB795' }} />{' '}
            {t('payments.actions.cancelRefund')}
          </Box>
        </MenuItem>
        <MenuItem
          disabled={
            !(
              refund.refund_status === REFUND_STATUSES.UNCLAIMED ||
              refund.refund_status === REFUND_STATUSES.EXCEPTION
            )
          }
          onClick={handleSetToDormant}>
          <Box display='flex' gap='10px'>
            <Bedtime style={{ color: '#3AB795' }} />
            {t('payments.actions.setToDormant')}
          </Box>
        </MenuItem>
      </Menu>
    </div>
  );
}
